import { render } from "./ModalCard.vue?vue&type=template&id=00b7a1f0"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__